import {Component, OnInit} from '@angular/core';
import {
    MxForgotPasswordComponent
} from '../../../../../../../mx-core/src/lib/modules/mx-authentication/mx-forgot-password/mx-forgot-password.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'prl-external-reset-password',
    templateUrl: './prl-external-reset-password.component.html',
    standalone: false,
    styleUrls: ['prl-external-reset-password.components.scss']
})
export class PrlExternalResetPasswordComponent implements OnInit {
    constructor(
        private readonly dialogRef: MatDialog,
    ) {}

    ngOnInit() {
        this.dialogRef.open(
            MxForgotPasswordComponent, {
                panelClass: 'mx-dialog-panel-class',
                width: '250px',
                data: {
                    showOld: true
                }
            });
    }
}
